import React from "react";
import {
  MathpixLoader,
  MathpixMarkdown,
} from "mathpix-markdown-it";
import "katex/dist/katex.min.css";

function LatexPreview({ math, style, className }) {

  return (
    <div style={style} className={className}>
      <MathpixLoader>
        <MathpixMarkdown text={`${math}`} />
      </MathpixLoader>
    </div>
  );
}

export default LatexPreview;
